module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-500.woff?1372de09cfc3e9a62af4234fd331e8e9";